const Login = () => import("@/page/Login");
const Loginmain = () => import("@/page/login/Login");
const userregistration = () => import("@/page/login/userregistration");
const WXvalidation = () => import("@/page/login/WXvalidation");
const bindpassword = () => import("@/page/login/bindpassword");
const filloutinfo = () => import("@/page/login/filloutinfo");
const mobilebinding = () => import("@/page/login/mobilebinding");

export default {
  path: "/Login",
  component: Login,
  children:[ {
      path: 'login',
      name: 'login',
      component:Loginmain,
    },{
      path: 'WXvalidation',
      name: 'WXvalidation',
      component:WXvalidation,
    },{
      path: 'userregistration',
      name: 'userregistration',
      component:userregistration,
    },{
      path: 'bindpassword',
      name: 'bindpassword',
      component:bindpassword,
    },{
      path: 'filloutinfo',
      name: 'filloutinfo',
      component:filloutinfo,
    },{
      path: 'mobilebinding',
      name: 'mobilebinding',
      component:mobilebinding,
    }]

};



// WEBPACK FOOTER //
// ./src/router/login.js